import { render, staticRenderFns } from "./add.vue?vue&type=template&id=e0e798c6&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=e0e798c6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e798c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0e798c6')) {
      api.createRecord('e0e798c6', component.options)
    } else {
      api.reload('e0e798c6', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=e0e798c6&scoped=true", function () {
      api.rerender('e0e798c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchase/purchaseReturn/add.vue"
export default component.exports